import { useQuery } from "react-query";
import Select from "react-select"


import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getBranches } from "../../../../../MyApi/sb/branches";

import LoadingSpinner from "../../../../UI/spinner"
import icons from "../../../../../Data/icons";

import classes from "./addDevice.module.css";

const AddDevice = ({

  deviceName, uuid,companyId, major,status, minor,mac, branchId ,setCompanyId, setStatus ,setMinor  ,setMajor ,setUuid ,setMac, setBranchId ,setDeviceName
}) => {
 
  const page =0
const companyQuery = useQuery("getcompanies" , getCompanies)
const branchQuery = useQuery(["getBranches" , page ,companyId] , ()=>getBranches(page ,companyId),{
  enabled:!!companyId
})


const branches = branchQuery.data?.data || []
const companies =companyQuery.data?.data || []




 const Device = icons.device
 const Status = ['pending','active','canceled']


  const handleNameChange = (e) => {
    setDeviceName(e.target.value);
  };

  const handleBranchIdChange =(selectBranch)=>{
    const branch =selectBranch ?selectBranch.id :0
    setBranchId(branch)
  }
  const handleCompanyIdChange =(selectedCompany)=>{
  const company = selectedCompany?selectedCompany.id:0
    setCompanyId(company)
  }
  const handleUiidChange =(e)=>{
    setUuid(e.target.value)
  }
 const handleMacChange =(e)=>{
  setMac(e.target.value)
 }
 const handleMajorChange =(e)=>{
  setMajor(e.target.value)
 }
 const handleMinorChange =(e)=>{
  setMinor(e.target.value)
 }
const handleStatusChange =(e)=>{
  setStatus(e.target.value)
}




  return (
    <div className={classes.formCard}>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الجهاز</label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={deviceName}
            placeholder="ادخل اسم الجهاز"
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">uuid </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={uuid}
     
            placeholder=" uuid "
            onChange={handleUiidChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">mac </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
             value={mac}
            placeholder="mac"
            onChange={handleMacChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">major </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={major}
            placeholder="Major"
            onChange={handleMajorChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">minor </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
            value={minor}
            placeholder="Minor"
            onChange={handleMinorChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">status </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <select
            type="text"
            
            placeholder="Status"
            onChange={handleStatusChange}
            className={classes.inputCustom}
          >
            <option value="">اختار الحالة</option>
            {Status.map(( stats,i )=>(
              <option key={i} value={stats}>{stats}</option>
            ))}
          </select>
        </div>


        <div className={classes.formCol}>
          <label htmlFor="company">  اختار الشركة</label>

        {!companyQuery.data ?<div> no data available</div> :
        <Select
            type="text"
            placeholder="اختار الشركة"
            options={companies}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            onChange={handleCompanyIdChange}
          />
           }
        </div>

        <div className={classes.formCol}>
          <label htmlFor="company">  اختار الفرع</label>

       {!branchQuery.data ? <div>يجب اختيار شركة </div>
       : 
         <Select
            type="text"
            placeholder="اختار الفرع"
            options={branches}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            onChange={handleBranchIdChange}
         />
      }
      
        </div>

      
    </div>
    </div>
  );
};

export default AddDevice;
